import { Button, Tooltip } from "@coval/ui"

interface TestSetHeaderActionsProps {
  hasChanges: boolean
  hasPending: boolean
  isNewTestSet: boolean
  isSaving: boolean
  isUnsavedNew: boolean
  onCancel: () => void
  onDiscard: () => void
  onSave: () => void
  testCaseCount: number
}

function SaveButton(input: {
  disabled: boolean
  label: string
  onSave: () => void
  tooltip: string | null
}) {
  const button = (
    <Button
      onClick={input.onSave}
      disabled={input.disabled}
      className="text-sm"
      data-testid="test-set-editor-save-button"
    >
      {input.label}
    </Button>
  )

  return input.tooltip ? (
    <Tooltip content={input.tooltip} side="bottom">
      <div data-testid="test-set-editor-save-wrapper">{button}</div>
    </Tooltip>
  ) : (
    button
  )
}

export function TestSetHeaderActions({
  hasChanges,
  hasPending,
  isNewTestSet,
  isSaving,
  isUnsavedNew,
  onCancel,
  onDiscard,
  onSave,
  testCaseCount,
}: TestSetHeaderActionsProps) {
  if (isNewTestSet || isUnsavedNew) {
    const isEmpty = testCaseCount === 0 && !hasPending

    return (
      <div className="flex items-center gap-2 shrink-0">
        <Button variant="ghost" onClick={onDiscard} className="text-sm">
          Discard
        </Button>
        <SaveButton
          disabled={isSaving || isEmpty}
          label={
            isUnsavedNew
              ? isSaving
                ? "Creating..."
                : "Create"
              : isSaving
                ? "Saving..."
                : "Save"
          }
          onSave={onSave}
          tooltip={isEmpty ? "Add at least one test case" : null}
        />
      </div>
    )
  }

  if (!hasChanges && !hasPending) {
    return null
  }

  const isEmpty = testCaseCount === 0 && !hasPending
  return (
    <div className="flex items-center gap-2 shrink-0">
      <Button variant="ghost" onClick={onCancel} className="text-sm">
        Cancel
      </Button>
      <SaveButton
        disabled={isSaving || isEmpty}
        label={isSaving ? "Saving..." : "Save"}
        onSave={onSave}
        tooltip={isEmpty ? "Add at least one test case" : null}
      />
    </div>
  )
}
